import { render, staticRenderFns } from "./SocialProductsIndex.vue?vue&type=template&id=8eca2220"
import script from "./SocialProductsIndex.vue?vue&type=script&lang=js"
export * from "./SocialProductsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports